import { render, staticRenderFns } from "./UmsatzHorizontalBar.vue?vue&type=template&id=22ab84a5&"
import script from "./UmsatzHorizontalBar.vue?vue&type=script&lang=ts&"
export * from "./UmsatzHorizontalBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports